/* SIDONIA · Profesionales (sections/sidonia-profesionales.liquid).
 * La lista (snippets/sidonia-profesionales-datos.liquid + los bloques de Personalizar), el buscador, los filtros, «Cerca de mí»,
 * el mapa (Leaflet con OpenStreetMap en gris claro; con grupos de pines),
 * las tarjetas deslizables sobre el mapa y la ficha de cada uno con las opiniones de la comunidad (el motor:
 * servicios/subastas/lib/opiniones.mjs). ?p=<id> abre una ficha.
 */
(() => {
  const root = document.querySelector('.sidonia-pro');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  const $ = (s, el = root) => el.querySelector(s);
  const esc = (t) => String(t ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const norm = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9 ]+/g, ' ');
  const leer = (sel) => { try { return JSON.parse($(sel)?.textContent || '[]'); } catch (e) { return []; } };

  const SECTORES = {
    restauracion: { n: 'Restauración', i: '<path d="M14.7 6.3a4 4 0 0 0-5.4 5.2L4 16.8 7.2 20l5.3-5.3a4 4 0 0 0 5.2-5.4l-2.6 2.6-2.4-.6-.6-2.4z"/>' },
    chapa: { n: 'Chapa y pintura', i: '<path d="M4 15.5 13.5 6a2.1 2.1 0 0 1 3 3L7 18.5H4z"/><path d="M15 4.5 19.5 9M17 20h4"/>' },
    mecanica: { n: 'Mecánica', i: '<circle cx="12" cy="12" r="3"/><path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.3 5.3l2.1 2.1M16.6 16.6l2.1 2.1M5.3 18.7l2.1-2.1M16.6 7.4l2.1-2.1"/>' },
    tapiceria: { n: 'Tapicería', i: '<path d="M7 20v-3h10v3M6 17c-1.5-4-1.5-9 1-12.5h10C19.5 8 19.5 13 18 17"/><path d="M9 9h6"/>' },
    motos: { n: 'Motos', i: '<circle cx="5.5" cy="16" r="3.5"/><circle cx="18.5" cy="16" r="3.5"/><path d="M5.5 16 9 9h5l4.5 7M9 9 7.5 6H5M14 9l1.5-3h2.5"/>' },
    servicios: { n: 'Guardería, transporte y más', i: '<path d="M3 17V8l9-4 9 4v9"/><path d="M6 17h12M6 13.5h12M6 20h12"/>' }
  };
  const ORDEN_SEC = Object.keys(SECTORES);
  const ico = (s, w = 20) => `<svg aria-hidden="true" width="${w}" height="${w}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">${(SECTORES[s] || SECTORES.servicios).i}</svg>`;
  const STAR = (w = 14) => `<svg aria-hidden="true" width="${w}" height="${w}" viewBox="0 0 24 24" fill="currentColor"><path d="m12 2.8 2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 16.8l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z"/></svg>`;
  const PIN = '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-6.5-6-6.5-11a6.5 6.5 0 0 1 13 0c0 5-6.5 11-6.5 11Z"/><circle cx="12" cy="10" r="2.3"/></svg>';
  const CIUDADES = { madrid: [40.4168, -3.7038], barcelona: [41.3874, 2.1686], valencia: [39.4699, -0.3763], sevilla: [37.3891, -5.9845], malaga: [36.7213, -4.4214], bilbao: [43.263, -2.935], zaragoza: [41.6488, -0.8891] };
  const num = (v) => { const n = parseFloat(String(v ?? '').replace(',', '.')); return isFinite(n) ? n : null; };

  /* 1 · Los datos: la lista base y, encima, los bloques de Personalizar (si un bloque usa un id que ya existe, lo cambia) */
  const porId = new Map();
  [...leer('[data-pr-datos]'), ...leer('[data-pr-extra]')].forEach((p) => {
    if (!p || !p.nombre) return;
    p.id = String(p.id || p.nombre).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);
    if (p.oculto) { porId.delete(p.id); return; }
    porId.set(p.id, { ...(porId.get(p.id) || {}), ...Object.fromEntries(Object.entries(p).filter(([, v]) => v !== '' && v !== null && v !== undefined)) });
  });
  const pros = [...porId.values()];
  const vistos = {};
  pros.forEach((p) => {
    if (!SECTORES[p.sector]) p.sector = 'servicios';
    let lat = num(p.lat), lng = num(p.lng);
    p.aprox = !p.direccion;
    if (lat === null || lng === null) { const c = CIUDADES[norm(p.zona).trim()]; if (c) [lat, lng] = c; }
    if (lat !== null && lng !== null) {
      const k = lat.toFixed(3) + ',' + lng.toFixed(3);
      const n = (vistos[k] = (vistos[k] || 0) + 1);
      // Los que caen en el mismo punto (mismo pueblo sin calle), un poco separados en espiral
      if (n > 1) { const a = n * 2.39996, r = 0.0045 * Math.sqrt(n); lat += Math.sin(a) * r; lng += Math.cos(a) * r * 1.3; }
      p.pos = [lat, lng];
    }
    p._q = norm([p.nombre, SECTORES[p.sector].n, p.especialidad, p.palabras, p.zona, p.provincia, p.nota].join(' '));
    p.media = 0; p.n = 0;
  });

  const cfg = root.dataset;
  const cuenta = $('[data-pr-count]'), vacio = $('[data-pr-empty]');
  const q = $('[data-pr-q]'), limpiar = $('[data-pr-clear]'), cerca = $('[data-pr-near]');
  const orden = { value: 'top' };
  const mapEl = $('[data-pr-map]'), enZona = $('[data-pr-bounds]'), carrusel = $('[data-pr-carousel]');
  const movil = () => matchMedia('(max-width: 999px)').matches;
  let sector = '', yo = null, map = null, L = null, capa = null, limite = 24, visibles = [], seleccionado = null;
  const marcas = new Map();

  /* Los sectores, como en Explorar: icono y nombre corto */
  const CORTO = { restauracion: 'Restauración', chapa: 'Chapa y pintura', mecanica: 'Mecánica', tapiceria: 'Tapicería', motos: 'Motos', servicios: 'Guardería y más' };
  const TODOS = '<svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="4" width="6.5" height="6.5" rx="1.6"/><rect x="13.5" y="4" width="6.5" height="6.5" rx="1.6"/><rect x="4" y="13.5" width="6.5" height="6.5" rx="1.6"/><rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1.6"/></svg>';
  const chips = $('[data-pr-chips]');
  chips.innerHTML = `<button type="button" class="pr__cat is-on" data-s="" aria-pressed="true"><span class="pr__catic">${TODOS}</span><b>Todos</b></button>` +
    ORDEN_SEC.filter((s) => pros.some((p) => p.sector === s)).map((s) => `<button type="button" class="pr__cat" data-s="${s}" aria-pressed="false" style="--c:var(--c-${s})"><span class="pr__catic">${ico(s, 20)}</span><b>${esc(CORTO[s])}</b></button>`).join('');

  const km = (a, b) => { const r = Math.PI / 180, dLa = (b[0] - a[0]) * r, dLo = (b[1] - a[1]) * r; const h = Math.sin(dLa / 2) ** 2 + Math.cos(a[0] * r) * Math.cos(b[0] * r) * Math.sin(dLo / 2) ** 2; return 12742 * Math.asin(Math.sqrt(h)); };
  const kmTxt = (d) => 'a ' + (d < 10 ? d.toFixed(1).replace('.', ',') : Math.round(d)) + ' km';
  const nota = (m) => m.toFixed(1).replace('.', ',');
  const HEART = (on) => `<svg aria-hidden="true" width="17" height="17" viewBox="0 0 24 24" fill="${on ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"><path d="M12 20.5s-7.5-4.6-9.2-9.4C1.6 7.6 3.9 4.5 7.2 4.5c2 0 3.6 1.1 4.8 2.8 1.2-1.7 2.8-2.8 4.8-2.8 3.3 0 5.6 3.1 4.4 6.6-1.7 4.8-9.2 9.4-9.2 9.4Z"/></svg>`;
  const TEL = '<svg aria-hidden="true" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M5 4h3.5l1.8 4.5-2.3 1.4a11 11 0 0 0 6.1 6.1l1.4-2.3L20 15.5V19a1 1 0 0 1-1 1A16 16 0 0 1 4 5a1 1 0 0 1 1-1Z"/></svg>';
  const telDe = (p) => String(p.telefono || '').replace(/[^\d+]/g, '');
  const dirUrl = (p) => `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent([p.nombre, p.direccion, p.zona, p.provincia].filter(Boolean).join(', '))}`;
  /* La foto del profesional; si no hay, su sector en grande, con su color */
  function foto(p, w) {
    if (p.foto) return `<img src="${esc(p.foto)}" alt="" loading="lazy" decoding="async">`;
    return `<span class="pr__phico">${ico(p.sector, 30)}</span>`;
  }
  const mios = new Set();
  let likesN = {};

  /* 2 · Las tarjetas */
  function tarjeta(p) {
    const rate = p.n ? `<span class="pr__stars">${STAR()}${nota(p.media)} <span style="font-weight:400;color:var(--pr-soft)">(${p.n})</span></span>` : '<span class="pr__new">Sin opiniones aún</span>';
    const tel = telDe(p), on = mios.has(p.id), nl = likesN[p.id] || 0;
    return `<li class="pr__card${seleccionado === p.id ? ' is-hl' : ''}" data-id="${esc(p.id)}" tabindex="0" role="button" aria-label="${esc(p.nombre)}: ver ficha" style="--c:var(--c-${p.sector})">
      <span class="pr__ph" aria-hidden="true">${foto(p)}</span>
      <div class="pr__cb">
        <div class="pr__top"><span class="pr__sec">${esc(SECTORES[p.sector].n)}</span>${p.recomendado ? `<span class="pr__rec">${STAR(11)}Sidonia</span>` : ''}${yo && p.pos ? `<span class="pr__dist">${kmTxt(p.d)}</span>` : ''}</div>
        <h2 class="pr__name">${esc(p.nombre)}</h2>
        ${p.especialidad ? `<p class="pr__spec">${esc(p.especialidad)}</p>` : ''}
        <p class="pr__meta">${rate}<span>${PIN}${esc(p.zona || 'Sin dirección publicada')}${p.provincia && norm(p.provincia) !== norm(p.zona) ? ` · ${esc(p.provincia)}` : ''}</span></p>
        <div class="pr__acts">
          ${tel ? `<a class="pr__act" href="tel:${esc(tel)}" data-stop>${TEL}Llamar</a>` : ''}
          <a class="pr__act pr__act--ic" href="${esc(dirUrl(p))}" target="_blank" rel="noopener" data-stop aria-label="Cómo llegar a ${esc(p.nombre)}">${PIN}</a>
          <button type="button" class="pr__act pr__like" data-like="${esc(p.id)}" aria-pressed="${on}" aria-label="Me gusta ${esc(p.nombre)}">${HEART(on)}<span>${nl || ''}</span></button>
        </div>
      </div></li>`;
  }
  const abrirDesde = (el) => el.querySelectorAll('[data-id]').forEach((c) => {
    c.querySelectorAll('[data-stop]').forEach((a) => a.addEventListener('click', (e) => e.stopPropagation()));
    c.querySelectorAll('[data-like]').forEach((b) => b.addEventListener('click', (e) => { e.stopPropagation(); darLike(b.dataset.like); }));
    c.addEventListener('click', () => abrir(c.dataset.id));
    c.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); abrir(c.dataset.id); } });
    c.addEventListener('mouseenter', () => resaltar(c.dataset.id, false));
  });

  const abc = new Intl.Collator('es').compare; // uno para todo (localeCompare con idioma crea uno en cada comparación)
  let ultimoHtml = null, ultimoIds = null;
  function filtrar({ encuadrar = true, porMapa = false } = {}) {
    const palabras = norm(q.value).split(' ').filter(Boolean);
    const caja = enZona && enZona.checked && map ? map.getBounds() : null;
    let l = pros.filter((p) => (!sector || p.sector === sector) && palabras.every((w) => p._q.includes(w)));
    const enMapa = l;
    if (caja) l = l.filter((p) => p.pos && caja.contains(p.pos));
    const o = orden.value;
    l.sort((a, b) => {
      if (o === 'cerca' && yo) return (a.d ?? 1e9) - (b.d ?? 1e9);
      if (o === 'gusta') return ((likesN[b.id] || 0) - (likesN[a.id] || 0)) || abc(a.nombre, b.nombre);
      if (o === 'nota') return (b.media - a.media) || (b.n - a.n) || abc(a.nombre, b.nombre);
      return (b.recomendado ? 1 : 0) - (a.recomendado ? 1 : 0) || (b.n ? 1 : 0) - (a.n ? 1 : 0) || (b.media - a.media) || abc(a.nombre, b.nombre);
    });
    visibles = l;
    cuenta.innerHTML = `<b>${l.length}</b> ${l.length === 1 ? 'profesional' : 'profesionales'}`;
    vacio.hidden = l.length > 0;
    limpiar.hidden = !q.value;
    // Solo se rehacen las tarjetas si algo ha cambiado (al entrar se llama varias veces: datos, notas, likes, mapa)
    const html = l.map(tarjeta).join('');
    if (html !== ultimoHtml) {
      const misma = ultimoIds === (ultimoIds = l.map((p) => p.id).join());
      ultimoHtml = html;
      const x = carrusel.scrollLeft;
      carrusel.innerHTML = html;
      carrusel.scrollLeft = misma ? x : 0;
      abrirDesde(carrusel);
      requestAnimationFrame(flechas);
    }
    if (map && !porMapa) {
      pintarPines(enMapa);
      if (encuadrar) encuadre(enMapa);
    }
  }

  /* 3 · El mapa */
  function pinIcon(p, hl) {
    return L.divIcon({ className: '', iconSize: [36, 44], iconAnchor: [18, 44], popupAnchor: [0, -40],
      html: `<div class="pr-pin${p.aprox ? ' pr-pin--aprox' : ''}${hl ? ' is-hl' : ''}" style="--c:var(--c-${p.sector})">${ico(p.sector, 17)}${p.recomendado ? `<b>${STAR(9)}</b>` : ''}</div>` });
  }
  function pintarPines(l) {
    if (!map) return;
    capa.clearLayers();
    marcas.clear();
    l.filter((p) => p.pos).forEach((p) => {
      const m = L.marker(p.pos, { icon: pinIcon(p, seleccionado === p.id), title: p.nombre, riseOnHover: true, keyboard: true });
      // Al tocar un pin: se marca y su tarjeta se pone delante (tocar la tarjeta abre la ficha)
      m.on('click', () => { resaltar(p.id, false); aTarjeta(p.id); });
      capa.addLayer(m);
      marcas.set(p.id, m);
    });
  }
  function encuadre(l = visibles, animar = true) {
    if (!map) return;
    if (!animar) {
      const pts = l.filter((p) => p.pos).map((p) => p.pos);
      if (pts.length > 1) map.fitBounds(L.latLngBounds(pts).pad(0.1), { animate: false, maxZoom: 12, paddingTopLeft: [20, 70], paddingBottomRight: [20, movil() ? 230 : 200] });
      else if (pts.length === 1) map.setView(pts[0], 13, { animate: false });
      return;
    }
    const pts = l.filter((p) => p.pos).map((p) => p.pos);
    if (yo) pts.push(yo);
    map.invalidateSize();
    if (pts.length > 1) map.flyToBounds(L.latLngBounds(pts).pad(0.1), { maxZoom: 12, duration: 0.7, paddingTopLeft: [20, 70], paddingBottomRight: [20, movil() ? 230 : 200] });
    else if (pts.length === 1) map.flyTo(pts[0], 13, { duration: 0.7 });
    else map.flyTo([40.2, -3.7], 5.6, { duration: 0.7 });
  }
  function resaltar(id, volar) {
    const antes = seleccionado;
    seleccionado = id;
    root.querySelectorAll('.pr__card').forEach((c) => c.classList.toggle('is-hl', c.dataset.id === id));
    [antes, id].forEach((k) => { const m = k && marcas.get(k); const p = k && porId.get(k); if (m && p) m.setIcon(pinIcon(p, k === id)); });
    const m = id && marcas.get(id);
    if (m && volar && map) {
      if (capa.zoomToShowLayer) capa.zoomToShowLayer(m, () => {});
      else map.panTo(m.getLatLng(), { animate: true });
    }
  }
  /* El carrusel: la tarjeta de un profesional, delante; flechas en ordenador */
  function aTarjeta(id) {
    const c = carrusel.querySelector(`[data-id="${CSS.escape(id)}"]`);
    if (c) carrusel.scrollTo({ left: c.offsetLeft - (carrusel.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' });
  }
  const prev = $('[data-pr-prev]'), next = $('[data-pr-next]');
  function flechas() {
    if (!prev) return;
    const max = carrusel.scrollWidth - carrusel.clientWidth - 4;
    prev.hidden = carrusel.scrollLeft <= 4; next.hidden = carrusel.scrollLeft >= max;
  }
  const paso = () => Math.max(260, carrusel.clientWidth * 0.8);
  prev && prev.addEventListener('click', () => carrusel.scrollBy({ left: -paso(), behavior: 'smooth' }));
  next && next.addEventListener('click', () => carrusel.scrollBy({ left: paso(), behavior: 'smooth' }));
  let tf;
  carrusel.addEventListener('scroll', () => {
    clearTimeout(tf);
    tf = setTimeout(() => {
      flechas();
      // En el móvil, la tarjeta que queda en el centro marca su pin
      if (!movil()) return;
      const mid = carrusel.scrollLeft + carrusel.clientWidth / 2;
      const c = [...carrusel.children].find((x) => x.offsetLeft <= mid && x.offsetLeft + x.offsetWidth >= mid);
      if (c && c.dataset.id !== seleccionado) { resaltar(c.dataset.id, false); const m = marcas.get(c.dataset.id); if (m && map && !map.getBounds().pad(-0.15).contains(m.getLatLng())) map.panTo(m.getLatLng(), { animate: true }); }
    }, 120);
  }, { passive: true });

  let carga;
  // Cada cosa desde varios sitios: si uno falla (o tarda más de 8 s), el siguiente
  const FUENTES = {
    'leaflet.css': ['https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css', 'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.css', 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css'],
    'leaflet.js': ['https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js', 'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.js', 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js'],
    'cluster.js': ['https://cdnjs.cloudflare.com/ajax/libs/leaflet.markercluster/1.5.3/leaflet.markercluster.min.js', 'https://cdn.jsdelivr.net/npm/leaflet.markercluster@1.5.3/dist/leaflet.markercluster.js', 'https://unpkg.com/leaflet.markercluster@1.5.3/dist/leaflet.markercluster.js']
  };
  const uno = (tipo, url) => new Promise((ok, ko) => {
    const el = document.createElement(tipo === 'css' ? 'link' : 'script');
    const t = setTimeout(() => { el.remove(); ko(new Error('tiempo')); }, 8000);
    el.onload = () => { clearTimeout(t); ok(); };
    el.onerror = () => { clearTimeout(t); el.remove(); ko(new Error('error')); };
    if (tipo === 'css') { el.rel = 'stylesheet'; el.href = url; } else el.src = url;
    document.head.appendChild(el);
  });
  const traer = (k) => FUENTES[k].reduce((p, url) => p.catch(() => uno(k.endsWith('.css') ? 'css' : 'js', url)), Promise.reject());
  function cargarMapa() {
    if (carga) return carga;
    traer('leaflet.css').catch(() => null);
    carga = (window.L && window.L.map ? Promise.resolve() : traer('leaflet.js'))
      .then(() => traer('cluster.js').catch(() => null))
      .then(montar)
      .catch((e) => { console.error('Sidonia · mapa', e); carga = null; mapEl.innerHTML = '<p class="pr__maploading">No se ha podido cargar el mapa. <button type="button" class="pr__retry">Reintentar</button></p>'; mapEl.querySelector('.pr__retry').addEventListener('click', () => { mapEl.innerHTML = '<p class="pr__maploading">Cargando el mapa…</p>'; cargarMapa(); }); });
    return carga;
  }
  /* El fondo: OpenStreetMap en imágenes, en gris claro (el estilo, en el CSS). Ligero: antes iba un segundo mapa
   * vectorial (MapLibre, ~800 KB y WebGL) debajo de Leaflet y en los móviles hacía que la página fuera a tirones */
  function fondo() {
    mapEl.classList.add('is-osm');
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, updateWhenIdle: true, keepBuffer: 1,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>' }).addTo(map);
  }
  function montar() {
    L = window.L;
    mapEl.querySelector('.pr__maploading')?.remove();
    map = L.map(mapEl, { scrollWheelZoom: false, zoomSnap: 0.5, zoomControl: false, attributionControl: true, tap: true }).setView([40.2, -3.7], 5.6);
    L.control.zoom({ position: 'topright' }).addTo(map);
    fondo();
    capa = L.markerClusterGroup
      ? L.markerClusterGroup({ showCoverageOnHover: false, spiderfyOnMaxZoom: true, maxClusterRadius: 46, spiderfyDistanceMultiplier: 1.6,
          iconCreateFunction: (c) => { const n = c.getChildCount(), s = n < 10 ? 42 : n < 30 ? 50 : 58; return L.divIcon({ className: '', iconSize: [s, s], html: `<div class="pr-cluster">${n}</div>` }); } })
      : L.layerGroup();
    capa.addTo(map);
    // La rueda del ratón solo cuando se ha tocado el mapa (para no quedarse atrapado al bajar por la página)
    map.on('click focus', () => map.scrollWheelZoom.enable());
    mapEl.addEventListener('mouseleave', () => map.scrollWheelZoom.disable());
    map.on('moveend', () => { if (enZona && enZona.checked) filtrar({ porMapa: true }); });
    filtrar({ encuadrar: false });
    // Primer encuadre de golpe, sin animación (más rápido al entrar)
    encuadre(pros.filter((p) => marcas.has(p.id)), false);
  }
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((e) => { if (e.some((x) => x.isIntersecting)) { io.disconnect(); cargarMapa(); } }, { rootMargin: '300px' });
    io.observe(mapEl);
  } else cargarMapa();

  /* «Añadir profesional»: la ventana con el formulario (se abre sola al volver de enviarlo) */
  const alta = document.getElementById(`${root.id}-recomienda`);
  if (alta) {
    root.querySelectorAll('[data-pr-add]').forEach((b) => b.addEventListener('click', () => alta.showModal()));
    alta.querySelector('[data-pr-add-close]').addEventListener('click', () => alta.close());
    alta.addEventListener('click', (e) => { if (e.target === alta) alta.close(); });
    if (alta.querySelector('.pr__ok, .pr__err')) alta.showModal();
  }

  /* Filtros */
  let tq;
  q.addEventListener('input', () => { clearTimeout(tq); tq = setTimeout(() => filtrar(), 160); });
  q.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); q.blur(); filtrar(); } });
  limpiar.addEventListener('click', () => { q.value = ''; filtrar(); q.focus(); });
  if (enZona) enZona.addEventListener('change', () => filtrar({ encuadrar: false }));
  chips.addEventListener('click', (e) => {
    const b = e.target.closest('[data-s]');
    if (!b) return;
    sector = b.dataset.s;
    chips.querySelectorAll('[data-s]').forEach((x) => { const on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on); });
    b.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
    filtrar();
  });

  function localizar() {
    if (!navigator.geolocation) return;
    const t = cerca.querySelector('span');
    t.textContent = '…';
    navigator.geolocation.getCurrentPosition((pos) => {
      yo = [pos.coords.latitude, pos.coords.longitude];
      pros.forEach((p) => { p.d = p.pos ? km(yo, p.pos) : null; });
      cerca.classList.add('is-on'); t.textContent = 'Cerca de ti';
      orden.value = 'cerca';
      if (map) { if (map._yo) map._yo.remove(); map._yo = L.marker(yo, { icon: L.divIcon({ className: '', iconSize: [18, 18], html: '<div class="pr-yo"></div>' }), keyboard: false, interactive: false }).addTo(map); }
      filtrar();
    }, () => { t.textContent = 'Cerca'; orden.value = 'top'; aviso('No hemos podido saber dónde estás. Busca tu ciudad.'); }, { timeout: 10000, maximumAge: 600000 });
  }
  cerca.addEventListener('click', () => {
    if (yo) { yo = null; cerca.classList.remove('is-on'); cerca.querySelector('span').textContent = 'Cerca'; orden.value = 'top'; if (map && map._yo) map._yo.remove(); filtrar(); return; }
    localizar();
  });

  function aviso(t) {
    const d = document.createElement('div'); d.className = 'pr-toast'; d.setAttribute('role', 'status'); d.textContent = t;
    document.body.appendChild(d); setTimeout(() => d.remove(), 2600);
  }

  /* 4 · El motor: las opiniones */
  async function api(ruta, init = {}) {
    const quien = cfg.quien ? `${ruta.includes('?') ? '&' : '?'}${cfg.quien}` : '';
    const opts = { headers: { Accept: 'application/json', ...(init.body ? { 'Content-Type': 'application/json' } : {}) }, ...init };
    const directo = (cfg.directo || '').replace(/\/+$/, '');
    let r = null;
    if (directo) r = await fetch(`${directo}/tienda/api/${ruta}${quien}`, opts).catch(() => null);
    const base = (cfg.engine || '/apps/sidonia').replace(/\/$/, '');
    if (!r || r.status === 404) r = await fetch(`${base}/api/${ruta}${quien}`, { credentials: 'same-origin', ...opts });
    return r.json();
  }
  api('opiniones/resumen').then((r) => {
    if (!r || !r.ok) return;
    Object.entries(r.pros || {}).forEach(([id, v]) => { const p = porId.get(id); if (p) { p.media = Number(v.media) || 0; p.n = Number(v.n) || 0; } });
    filtrar({ encuadrar: false });
  }).catch(() => {});

  /* «Me gusta» (pide entrar si no tiene sesión) */
  api('likes?tipo=pro').then((r) => { if (r && r.ok) { likesN = r.n || {}; (r.mios || []).forEach((x) => mios.add(x)); pintarLikes(); } }).catch(() => {});
  function pintarLikes() {
    document.querySelectorAll('[data-like]').forEach((b) => {
      const on = mios.has(b.dataset.like), n = likesN[b.dataset.like] || 0;
      b.setAttribute('aria-pressed', on);
      b.innerHTML = `${HEART(on)}<span>${n || ''}</span>${b.dataset.txt ? `<span>${on ? 'Te gusta' : 'Me gusta'}</span>` : ''}`;
    });
  }
  async function darLike(id) {
    if (!cfg.quien) {
      const back = new URL(location.href); back.searchParams.set('p', id);
      if (window.sidoniaLogin) window.sidoniaLogin(back.pathname + back.search, 'Entra (o únete gratis) para guardar los profesionales que te gustan.', 'guardar');
      return;
    }
    const on = !mios.has(id);
    if (on) mios.add(id); else mios.delete(id);
    likesN[id] = Math.max(0, (likesN[id] || 0) + (on ? 1 : -1));
    pintarLikes();
    const r = await api('likes', { method: 'POST', body: JSON.stringify({ tipo: 'pro', ref: id, on }) }).catch(() => null);
    if (r && r.ok) { likesN[id] = r.n; pintarLikes(); }
    else { if (on) mios.delete(id); else mios.add(id); likesN[id] = Math.max(0, (likesN[id] || 0) + (on ? -1 : 1)); pintarLikes(); aviso('No se ha podido guardar. Prueba otra vez.'); }
  }

  /* 5 · La ficha */
  const hoja = document.getElementById('sidonia-pro-ficha');
  const cuerpo = hoja.querySelector('[data-pr-sheet]');
  const mapsQ = (p) => encodeURIComponent([p.nombre, p.direccion, p.zona, p.provincia].filter(Boolean).join(', '));
  function barras(l) {
    const c = [5, 4, 3, 2, 1].map((s) => l.filter((o) => Number(o.nota) === s).length);
    return c.map((n, i) => `<div><span>${5 - i}</span><i style="--w:${l.length ? Math.round((n / l.length) * 100) : 0}%"></i></div>`).join('');
  }
  const fecha = (t) => { try { return new Date(t).toLocaleDateString('es-ES', { month: 'long', year: 'numeric' }); } catch (e) { return ''; } };

  function abrir(id, { opinar = false } = {}) {
    const p = porId.get(id);
    if (!p) return;
    resaltar(id, !movil() && Boolean(map));
    const tel = String(p.telefono || '').replace(/[^\d+]/g, '');
    const ig = String(p.instagram || '').replace(/^@/, '').trim();
    cuerpo.style.setProperty('--c', `var(--c-${p.sector})`);
    cuerpo.innerHTML = `
      <div class="pr-sheet__photo" aria-hidden="true">${foto(p)}</div>
      <div class="pr-sheet__band"><span class="pr-sheet__grab" aria-hidden="true"></span>
        <button type="button" class="pr-sheet__close" data-cerrar aria-label="Cerrar"><svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button>
        <div class="pr__top"><span class="pr__ico" style="width:2.4rem;height:2.4rem;border-radius:12px">${ico(p.sector, 18)}</span><span class="pr__sec">${esc(SECTORES[p.sector].n)}</span>${p.recomendado ? `<span class="pr__rec">${STAR(11)}Recomendado por Sidonia</span>` : ''}</div>
        <h2 id="sidonia-pro-ficha-t">${esc(p.nombre)}</h2>
        ${p.especialidad ? `<p class="pr-sheet__spec">${esc(p.especialidad)}</p>` : ''}
        ${p.nota ? `<p class="pr-sheet__note">${esc(p.nota)}</p>` : ''}
        <div class="pr-sheet__rate" data-rate>${p.n ? `<span class="pr__stars">${STAR(16)} ${nota(p.media)}</span><span>${p.n} ${p.n === 1 ? 'opinión' : 'opiniones'} en Sidonia</span>` : '<span class="pr__new">Aún nadie de Sidonia ha opinado</span>'}</div>
      </div>
      <div class="pr-sheet__body">
        <div class="pr-sheet__actions">
          ${tel ? `<a class="pr__btn" href="tel:${esc(tel)}">${TEL}Llamar · ${esc(p.telefono)}</a>` : ''}
          <a class="pr__btn" href="${esc(dirUrl(p))}" target="_blank" rel="noopener">${PIN}Cómo llegar</a>
          <button type="button" class="pr__btn pr__like" data-like="${esc(p.id)}" data-txt="1" aria-pressed="${mios.has(p.id)}">${HEART(mios.has(p.id))}<span>${likesN[p.id] || ''}</span><span>${mios.has(p.id) ? 'Te gusta' : 'Me gusta'}</span></button>
          ${p.web ? `<a class="pr__btn" href="${esc(p.web)}" target="_blank" rel="noopener">Web</a>` : ''}
          ${ig ? `<a class="pr__btn" href="https://www.instagram.com/${esc(ig)}/" target="_blank" rel="noopener">Instagram</a>` : ''}
          <a class="pr__btn" href="https://www.google.com/maps/search/?api=1&query=${mapsQ(p)}" target="_blank" rel="noopener">${STAR(13)}Reseñas Google</a>
          <button type="button" class="pr__btn" data-compartir>Compartir</button>
        </div>
        <p class="pr-sheet__where">${PIN}<span>${esc([p.direccion, p.zona].filter(Boolean).join(' · ') || 'Sin dirección publicada')}${p.provincia && norm(p.provincia) !== norm(p.zona) ? ` (${esc(p.provincia)})` : ''}<small>${p.aprox ? 'En el mapa, la zona aproximada: confirma la dirección antes de ir.' : 'Confirma el horario antes de ir.'}</small></span></p>
        <section class="pr-op" aria-labelledby="pr-op-t">
          <h3 id="pr-op-t">Opiniones de la comunidad</h3>
          <div data-op><p class="pr-op__empty">Cargando opiniones…</p></div>
        </section>
      </div>`;
    cuerpo.querySelector('[data-cerrar]').addEventListener('click', cerrar);
    cuerpo.querySelector('[data-like]').addEventListener('click', () => darLike(p.id));
    cuerpo.querySelector('[data-compartir]').addEventListener('click', async () => {
      const url = new URL(location.href); url.searchParams.set('p', p.id); url.hash = '';
      try { if (navigator.share) await navigator.share({ title: `${p.nombre} · SIDONIA`, text: p.especialidad || '', url: url.toString() }); else { await navigator.clipboard.writeText(url.toString()); aviso('Enlace copiado'); } } catch (e) { /* cancelado */ }
    });
    const url = new URL(location.href); url.searchParams.set('p', p.id);
    history.replaceState(null, '', url);
    if (!hoja.open) hoja.showModal();
    hoja.querySelector('.pr-sheet__scroll').scrollTop = 0;
    cargarOpiniones(p, opinar);
  }
  function cerrar() { hoja.close(); }
  hoja.addEventListener('close', () => { const url = new URL(location.href); url.searchParams.delete('p'); url.searchParams.delete('opinar'); history.replaceState(null, '', url); });
  hoja.addEventListener('click', (e) => { if (e.target === hoja) cerrar(); });

  async function cargarOpiniones(p, opinar) {
    const caja = cuerpo.querySelector('[data-op]');
    let r;
    try { r = await api(`opiniones?pro=${encodeURIComponent(p.id)}`); } catch (e) { r = null; }
    if (!r || !r.ok) {
      caja.innerHTML = `<p class="pr-op__empty">${r && r.error === 'sin-tabla' ? 'Las opiniones llegan muy pronto.' : 'No hemos podido cargar las opiniones ahora.'}</p>`;
      return;
    }
    p.media = r.media; p.n = r.n;
    const l = r.opiniones || [];
    caja.innerHTML = `
      ${l.length ? `<div class="pr-op__sum"><div class="pr-op__big"><b>${nota(r.media)}</b><span>${l.length} ${l.length === 1 ? 'opinión' : 'opiniones'}</span></div><div class="pr-op__bars">${barras(l)}</div></div>
      <ul class="pr-op__list" role="list">${l.map((o) => `<li class="pr-op__item"><header><span class="pr-op__av" aria-hidden="true">${esc((o.nombre || '?')[0].toUpperCase())}</span><span><b>${esc(o.nombre)}</b>${o.mia ? ' · <b>tú</b>' : ''}<br><small>${fecha(o.creado)}</small></span><span style="margin-left:auto;color:var(--pr-gold,#e8a317)" aria-label="${o.nota} de 5">${STAR(14).repeat(o.nota)}</span></header>${o.servicio || o.coche ? `<span class="pr-op__tags">${esc([o.servicio, o.coche].filter(Boolean).join(' · '))}</span>` : ''}<p>${esc(o.texto)}</p></li>`).join('')}</ul>`
      : '<p class="pr-op__empty">Sé la primera persona en contar qué tal te fue aquí.</p>'}
      ${formulario(p, r.mia)}`;
    const f = caja.querySelector('form');
    if (f) prepararForm(f, p);
    else caja.querySelector('[data-entrar]')?.addEventListener('click', () => {
      const back = new URL(location.href); back.searchParams.set('p', p.id); back.searchParams.set('opinar', '1');
      if (window.sidoniaLogin) window.sidoniaLogin(back.pathname + back.search, 'Entra (o únete gratis) para contar qué tal te fue con este profesional.', 'opinar');
    });
    if (opinar && f) setTimeout(() => f.scrollIntoView({ behavior: 'smooth', block: 'center' }), 250);
  }
  function formulario(p, mia) {
    if (!cfg.quien) return `<div class="pr-op__form"><b>¿Has ido? Cuéntalo</b><p style="margin:0;color:rgb(26 26 26 / .65)">Tus opiniones ayudan a la comunidad a elegir bien.</p><button type="button" class="pr__btn pr__btn--main" data-entrar>Escribir una opinión</button></div>`;
    const sv = ['Restauración', 'Chapa y pintura', 'Mecánica', 'Tapicería', 'Revisión', 'Otro'];
    return `<form class="pr-op__form" novalidate>
      <b>${mia ? 'Tu opinión (puedes cambiarla)' : '¿Has ido? Cuéntalo'}</b>
      <fieldset class="pr-starpick" aria-label="Tu nota">${[5, 4, 3, 2, 1].map((s) => `<input type="radio" name="nota" id="pr-s${s}" value="${s}"${mia && mia.nota === s ? ' checked' : ''}><label for="pr-s${s}" title="${s} de 5">${STAR(30)}<span class="sr-only">${s} de 5</span></label>`).join('')}</fieldset>
      <div class="pr-op__row">
        <label><span class="sr-only">Qué te hicieron</span><select name="servicio"><option value="">¿Qué te hicieron?</option>${sv.map((s) => `<option${mia && mia.servicio === s ? ' selected' : ''}>${s}</option>`).join('')}</select></label>
        <label><span class="sr-only">Tu coche o moto</span><input type="text" name="coche" maxlength="80" placeholder="Tu coche o moto (opcional)" value="${esc(mia ? mia.coche : '')}"></label>
      </div>
      <label><span class="sr-only">Tu opinión</span><textarea name="texto" maxlength="1500" placeholder="¿Qué tal el trato, el resultado, los plazos y el precio?">${esc(mia ? mia.texto : '')}</textarea></label>
      <p class="pr-op__err" data-err hidden></p>
      <div style="display:flex;gap:.5rem;flex-wrap:wrap"><button type="submit" class="pr__btn pr__btn--main">${mia ? 'Guardar cambios' : 'Publicar opinión'}</button>${mia ? '<button type="button" class="pr__btn" data-borrar>Borrar la mía</button>' : ''}</div>
    </form>`;
  }
  function prepararForm(f, p) {
    const err = f.querySelector('[data-err]');
    f.addEventListener('submit', async (e) => {
      e.preventDefault();
      const d = Object.fromEntries(new FormData(f));
      err.hidden = true;
      if (!d.nota) { err.textContent = 'Elige de 1 a 5 estrellas.'; err.hidden = false; return; }
      if (String(d.texto || '').trim().length < 10) { err.textContent = 'Cuéntanos un poco más (10 letras como mínimo).'; err.hidden = false; return; }
      const b = f.querySelector('[type="submit"]'); b.disabled = true;
      const r = await api('opiniones', { method: 'POST', body: JSON.stringify({ pro: p.id, nombre: cfg.nombre || '', ...d }) }).catch(() => null);
      b.disabled = false;
      if (!r || !r.ok) { err.textContent = r && r.error === 'login' ? 'Tu sesión ha caducado: vuelve a entrar.' : 'No se ha podido publicar. Prueba otra vez.'; err.hidden = false; return; }
      aviso('¡Gracias! Tu opinión ya se ve');
      await cargarOpiniones(p, false);
      actualizarNota(p);
    });
    f.querySelector('[data-borrar]')?.addEventListener('click', async () => {
      if (!confirm('¿Borrar tu opinión?')) return;
      await api('opiniones/borrar', { method: 'POST', body: JSON.stringify({ pro: p.id }) }).catch(() => null);
      await cargarOpiniones(p, false);
      actualizarNota(p);
    });
  }
  function actualizarNota(p) {
    const r = cuerpo.querySelector('[data-rate]');
    if (r) r.innerHTML = p.n ? `<span class="pr__stars">${STAR(16)} ${nota(p.media)}</span><span>${p.n} ${p.n === 1 ? 'opinión' : 'opiniones'} en Sidonia</span>` : '<span class="pr__new">Aún nadie de Sidonia ha opinado</span>';
    filtrar({ encuadrar: false });
  }

  filtrar({ encuadrar: false });
  const params = new URLSearchParams(location.search);
  if (params.get('q')) { q.value = params.get('q'); filtrar({ encuadrar: false }); }
  if (params.get('p') && porId.has(params.get('p'))) abrir(params.get('p'), { opinar: params.get('opinar') === '1' });
})();
